import { AuthActions } from './auth/AuthSlice';
import { DescriptionsActions } from './descriptions/DescriptionsSlice';

const actions = {
    ...AuthActions,
    ...DescriptionsActions
};

export default actions;
